export function shippingMethodDisplayName(shippingMethod, t) {
    if (shippingMethod?.remoteId === 'default') {
        return t('orders.unresolved-shipping', {defaultValue: 'Neurčená doprava'});
    }

    return shippingMethod?.name;
}
